// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__gaf-z","container":"styles_container__1NQEC","title":"styles_title__3lTAl","wrapper":"styles_wrapper__1Qcqc","answer":"styles_answer__3sQkE"};